import React, { useState, useMemo, useEffect } from "react";
import cx from "classnames";
import { makeRequest } from "../../../utils/request";
import PlaylistModal from "../../common/PlaylistModal";
import DownloadModal from "../../common/DownloadModal";
import LogsService from "../../../utils/logs";
import constants from "../../../config/constants";
import { getContentDetailsOnClick } from "../../../utils/utility";
import { useCallback } from "react";
import { isTokenExpired } from "../../../utils/persist";
const CardFooter = ({
  playlists,
  isAuthenticated,
  post,
  showShareModal,
  showFeedbackModal,
  feedbackSentContentKeys,
  canProceed,
  propGroup,
  userLikes,
  feedbacks,
  contentKey,
  id,
}) => {
  const comments = useMemo(() => {
    if (!feedbacks) return [];

    return feedbacks.filter((item) => item.contentKey === post.contentKey);
  }, [feedbacks, post.contentKey]);
  const [showDownloads, setShowDownloads] = useState(false);
  const [userLikeItems, setUserLikeItems] = useState(userLikes);
  const { downloadedContentKeys, setDownloadedContentKeys } = propGroup;
  const [likeState, setLikeState] = useState(false);
  const [isLiked, setIsLiked] = useState(false);
  const [isAuthenticatedfromToken, setIsAuthenticatedfromToken] = useState(false);
  const getStatusOfLikeForTheContent = async () => {
    const response = await makeRequest(
      "Get",
      `api/like/getuserlike?contentKey=${contentKey}`
    );
    setLikeState(response);
  };
  useEffect(() => {
    setIsAuthenticatedfromToken(!isTokenExpired());
  }, []);
  useEffect(() => {
    if (contentKey && id && !isLiked) {
      getStatusOfLikeForTheContent();
    } else {
      const liked = () => {
        if (!userLikeItems) return false;
        const index = userLikeItems.findIndex(
          (like) => like.contentKey === post.contentKey
        );
        return index !== -1 && userLikeItems[index].like;
      };
      const likeStatus = liked();
      setLikeState(likeStatus);
    }
  }, [contentKey, userLikeItems, id]);

  const bookMarkedPosts = () => {
    let allContentKeys = [];
    if (playlists) {
      playlists.forEach(
        (pl) => (allContentKeys = allContentKeys.concat(pl.contentKeys))
      );
    }
    allContentKeys = [...new Set(allContentKeys)];
    return allContentKeys;
  };
  const setIsLikedState = () => {
    setIsLiked(false);
  };
  const { transcripts, downloads } = useMemo(() => {
    let transcripts = [],
      downloads = [];
    if (post.referenceFiles)
      post.referenceFiles.forEach((file) => {
        if (
          file.showInDownloadList &&
          file.filePath &&
          file.filePath.trim().length
        ) {
          file.fileKey === "Transcripts"
            ? transcripts.push(file)
            : downloads.push(file);
        }
      });
    return { transcripts, downloads };
  }, [post.referenceFiles]);

  const onFeedback = () => {
    if (canProceed()) {
      showFeedbackModal(post);
    }
    getContentDetailsOnClick(post, "feedback", "card-footer");
    //await mutate("/api/playlist/getplaylistwithlikes", newUserLikes);
  };
  const onShare = async () => {
    if (canProceed()) {
      let subType = constants.edgeLoggingContentSubtypeMap[post.contentType];

      await LogsService.logShare({
        contentKey: post.contentKey,
        contentSubType: subType,
      });
      showShareModal(post);
    }
  };

  const toggleLike = async () => {
    if (canProceed()) {
      const data = {
        contentKey: post.contentKey,
        like: !likeState,
      };
      setIsLiked(true);
      const res = await makeRequest(
        "POST",
        `/api/like/postinteraction`,
        data
      ).then(() => {
        setIsLikedState();
        if (contentKey && id) {
          setLikeState(!likeState)
          setTimeout(() => {

            getStatusOfLikeForTheContent();
          }, 1000);
        }
      });
      // setLikeState(state =>!state);
      const newUserLikes = userLikeItems.slice();
      const index = newUserLikes.findIndex(
        (like) => like.contentKey === post.contentKey
      );
      if (!contentKey && !id) {
        const newLike = {
          contentKey: post.contentKey,
          like: !likeState,
        };
        if (index !== -1) {
          newUserLikes.splice(index, 1, newLike);
        } else {
          newUserLikes.push(newLike);
        }
        setUserLikeItems([...newUserLikes, newLike]);
      }
      let likeAction = "";
      if (data.like == true) {
        likeAction = "liked";
      } else {
        likeAction = "unlike";
      }
      getContentDetailsOnClick(post, likeAction, "card-footer");
      //await mutate("/api/playlist/getplaylistwithlikes", newUserLikes);
    }
  };
  const wasDownloaded = downloadedContentKeys.includes(post.contentKey);

  const onDownloaded = () => {
    if (!downloadedContentKeys.includes(post.contentKey)) {
      setDownloadedContentKeys([...downloadedContentKeys, post.contentKey]);
    }
  };
  return (
    <div>
      {(isAuthenticatedfromToken || !(post.isPublic && (post.publishUntilDate&& new Date (post.publishUntilDate) > new Date()) ) ) && ( <div
        className="flex flex-col items-center md:flex-row mt-5 px-5 border-t border-gray-500 btn-font"
        adoberegion="card-footer"
      >
        <div className="flex flex-no-wrap justify-between w-full">
          <div
            onClick={toggleLike}
            className="flex items-center my-2 md:px-3 md:my-5 lg:px-0 cursor-pointer"
          >
            <i
              className={cx("far fa-thumbs-up", {
                "text-orange-deep": likeState,
              })}
            ></i>
            <h5 className="hidden sm:block text-xs lg:text-sm font-normal ml-2">
              {likeState ? "Liked" : "Like"}
            </h5>
          </div>
          <PlaylistModal
            post={post}
            isAuthenticated={isAuthenticated}
            playlists={playlists}
          >
            <div className="flex items-center my-2 md:my-5 pl-3 lg:pl-5 cursor-pointer">
              <i
                className={`far fa-bookmark ${bookMarkedPosts().includes(post.contentKey)
                  ? "text-blue-400"
                  : ""
                  }`}
              ></i>
              <h5 className="hidden sm:block text-xs lg:text-sm ml-2 font-normal">
                {bookMarkedPosts().includes(post.contentKey) ? "Saved" : "Save"}
              </h5>
            </div>
          </PlaylistModal>
          <div
            onClick={onShare}
            className="flex items-center cursor-pointer my-2 lg:my-5 pl-3 lg:pl-5"
          >
            <i className="fas fa-share-square"></i>
            <h5 className="hidden sm:block text-xs lg:text-sm ml-2 font-normal">
              Share
            </h5>
          </div>
          {transcripts.length > 0 && (
            <div className="flex items-center cursor-pointer my-2 lg:my-5 pl-3 lg:pl-5">
              <i className="fas fa-file-alt"></i>
              <h5 className="hidden sm:block text-xs lg:text-sm ml-2 font-normal">
                Transcript
              </h5>
            </div>
          )}
          {downloads.length > 0 && (
            <div
              onClick={() => setShowDownloads(true)}
              className="flex items-center cursor-pointer my-2 lg:my-5 pl-3 lg:pl-5"
            >
              <i
                className={cx("fas fa-cloud-download-alt", {
                  "text-teal-500": wasDownloaded,
                })}
              ></i>
              <h5 className="hidden sm:block text-xs lg:text-sm ml-2 font-normal">
                Download
              </h5>
            </div>
          )}
          {downloads.length > 0 && showDownloads && (
            <DownloadModal
              post={post}
              downloads={downloads}
              onClose={() => setShowDownloads(false)}
              onDownloaded={() => onDownloaded()}
            />
          )}
          <div
            onClick={onFeedback}
            className="flex items-center cursor-pointer my-2 md:my-5 pl-3 lg:pl-5"
          >
            <i
              className={cx("far fa-comment-dots", {
                "text-red-500":
                  comments.length ||
                  (feedbackSentContentKeys &&
                    feedbackSentContentKeys.includes(post.contentKey)),
              })}
            ></i>
            <h5 className="hidden sm:block text-xs lg:text-sm ml-2 font-normal">
              Feedback
            </h5>
          </div>
        </div>
      </div>)}
    </div>
  );
};

export default CardFooter;
